/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { NotebookExecutionOutput } from '../models/NotebookExecutionOutput';

export class NotebookExecutionResult {
  /**
  * Unique identifier for this execution
  */
  'executionId': string;
  /**
  * Execution status
  */
  'status': NotebookExecutionResultStatusEnum;
  /**
  * Execution outputs
  */
  'outputs'?: Array<NotebookExecutionOutput> | null;
  /**
  * Error message if execution failed
  */
  'error'?: string | null;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "executionId",
      "baseName": "executionId",
      "type": "string",
      "format": ""
    },
    {
      "name": "status",
      "baseName": "status",
      "type": "NotebookExecutionResultStatusEnum",
      "format": ""
    },
    {
      "name": "outputs",
      "baseName": "outputs",
      "type": "Array<NotebookExecutionOutput>",
      "format": ""
    },
    {
      "name": "error",
      "baseName": "error",
      "type": "string",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return NotebookExecutionResult.attributeTypeMap;
  }

  public constructor() {
  }
}


export enum NotebookExecutionResultStatusEnum {
  NOTEBOOK_EXECUTION_STATUS_RUNNING = 'running',
  NOTEBOOK_EXECUTION_STATUS_COMPLETED = 'completed',
  NOTEBOOK_EXECUTION_STATUS_ERROR = 'error',
  NOTEBOOK_EXECUTION_STATUS_NOT_FOUND = 'not_found'
}

